import {
  SET_WEBINAR_LIST,
} from '../types';

const initialState = {
  webinarsList: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_WEBINAR_LIST:
      return {
        ...state,
        webinarsList: action.data,
      };
    default:
      return state;
  }
};
